import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const RejectionReasonModal = ({ 
  show, 
  onHide, 
  onSubmit, 
  title = "Enter Rejection Reason",
  submitText = "Submit",
  maxLength = 300 
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
   
    if (reason.length > maxLength) {
      setError(`Reason must be ${maxLength} characters or less`);
      return;
    }
    setError('');
    onSubmit(reason);
    setReason('');
    onHide();
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Reason for rejection/failure:</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={`Please provide a reason (max ${maxLength} characters)...`}
              maxLength={maxLength}
              isInvalid={!!error}
            />
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
              {reason.length}/{maxLength} characters
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleSubmit}>
          {submitText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectionReasonModal; 